import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import CommunityStats from "components/Home/CommunityStats";

interface UserFeedbackTileProps {
  businessOverallStats: BusinessOverallStatsType | null;
  isPlanActive: boolean;
}
const UserFeedbackTiles: React.FC<UserFeedbackTileProps> = ({
  businessOverallStats: feedback,
  isPlanActive,
}) => {
  const cardsStyles =
    "bg-brightPurple rounded-2xl  items-start md:px-8 md:py-12 p-8 w-full text-white flex-col gap-4 block md:h-[300px]";

  return (
    <div
      className={`flex  md:flex-row ${
        isPlanActive ? "flex-row" : "flex-col"
      } gap-4`}
    >
      <div className={`${cardsStyles}  md:!w-1/2  `}>
        <div className="md:text-3xl text-3xl mb-1 font-bold text-black">
          {feedback?.positiveInfluence}%
        </div>
        <div className="text-base text-black">
          of users have indicated that Open Rewards positively influenced their
          decision to shop local
        </div>
      </div>
      <div className={`${cardsStyles}  !bg-brightPurple `}>
        <CommunityStats businessOverallStats={feedback} />
      </div>
    </div>
  );
};

export default UserFeedbackTiles;
